'use client'

import { IconDone } from 'icons/components/IconDone'
import { IconErrorL } from 'icons/components/IconErrorL'
import { IconInfoL } from 'icons/components/IconInfoL'
import type { IconColor } from 'icons/types/Icon.types'

import styles from './Alert.module.scss'

const alertTypes = [
	'warning',
	'error',
	'info',
	'success',
	'importantAlert',
] as const

const icons = {
	warning: { color: 'semantic-warning', component: IconInfoL },
	info: { color: 'semantic-success', component: IconInfoL },
	error: { color: 'semantic-danger', component: IconErrorL },
	success: { color: 'semantic-success', component: IconDone },
	importantAlert: { color: 'semantic-danger', component: IconInfoL },
}

const ICON_WIDTH = 20
interface AlertProps {
	readonly children: JSX.Element | string
	readonly severity?: (typeof alertTypes)[number]
	readonly hideIcon?: boolean
}
export function Alert({
	children,
	severity = 'warning',
	hideIcon,
}: AlertProps) {
	const { component: Icon, color } = icons[severity]

	return (
		<div className={styles.alert}>
			{!hideIcon && (
				<Icon
					className={styles.icon}
					width={ICON_WIDTH}
					color={color as IconColor}
				/>
			)}
			<p className={`${styles.alertMessage} ${styles[severity]}`}>{children}</p>
		</div>
	)
}
